// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".work-place[data-v-26a225d0] {\n  padding-top: 10px;\n}\n.work-place-setup[data-v-26a225d0] {\n  position: absolute;\n  right: 0;\n  top: 30px;\n  cursor: pointer;\n  color: #3586ff;\n}\n", ""]);
// Exports
module.exports = exports;
